import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export const store = new Vuex.Store({
  state: {
    graybg: false,
    bannerdata: [],
    ban: "",
    islog: false,
    link: "",
    ddd: "",
    info: [],
    e404: false,
    e500: false,
    comments: [],
    name: "",
    looo: "",
    // url: "http://141.11.107.110/",
    url: "https://api.suncandle.ir/",
    // url:'http://sb.hasankhoda.ir/',
    // url:'https://f8d1-195-248-240-211.eu.ngrok.io/',
    user: {
      name: "",
    },
    co: "۰",
    pId: "",
    related: [],
    index: [],
    load: true,
    dec: {
      height: "",
      width: "",
      mat: "",
      length: "",
      sale: "",
    },
  },
});



// WEBPACK FOOTER //
// ./src/store/store.js